import { createContext, useContext } from 'react'

import type { VisitorChannel } from './types'
import { useSetVisitorChannelActions } from './useSetVisitorChannelActions'
import { useVisitorChannel } from './useVisitorChannel'

const VisitorChannelContext = createContext<VisitorChannel | undefined>(
  undefined,
)

/** @returns The visitor channel instance provided by the context. */
export function useVisitorChannelContext(): VisitorChannel | undefined {
  return useContext(VisitorChannelContext)
}

/** Visitor channel instance context provider. */
export const VisitorChannelProvider: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const channel = useVisitorChannel()
  useSetVisitorChannelActions(channel)

  return (
    <VisitorChannelContext.Provider value={channel}>
      {children}
    </VisitorChannelContext.Provider>
  )
}
